import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles(({ palette, variables,spacing }: Theme) => ({
  root: {
    textTransform: 'none',
    boxShadow: 'none',
    '& .MuiAccordion-rounded:last-child': {
      borderRadius: 'inherit',
    },
    '& .MuiPaper-elevation1': {
      boxShadow: 'none',
      borderTop: `1px solid ${palette.jet?.borderDefault}`,
      //borderBottom: `1px solid ${palette.jet?.borderDefault}`,
      '& .Mui-expanded': {
       // borderBottom: `1px solid ${palette.jet?.borderDefault} `,
      },
    },
    '& .MuiAccordionSummary-content': {
      flexGrow: '0',
      order: '2',
      color: palette.jet?.contentDefault,
      marginLeft: variables?.spacingA,
      '&.Mui-expanded': {
        borderBottom: '0 !important' ,
      },
    },
    '& .MuiCollapse-container': {
      borderTop: `1px solid ${palette.jet?.borderDefault} `,
    },
    '& .MuiAccordionDetails-root ': {
      padding: '0',
      '& ul': {
        padding: '0',
        width: '100%',
        '&.mobile': {
          maxHeight: '280px',
          overflow:'auto',
          paddingBottom: variables?.spacingB,
        },
        '& li': {
          marginBottom: '0',
          '& .listItemContent': {
            margin: `${variables?.spacingNone} ${variables?.spacingD}`,
          },
        },
        '& li:last-child:not(first-child)': {
          //borderBottom: 'inherit',
        },
      },
    },
    '& .MuiAccordionSummary-root': {
      height: '36px',
      paddingTop: '10px !important',
      minHeight: 'auto',
      '&.Mui-expanded': {
        height: '48px',
        minHeight: 'auto',
        padding: '10px',
        borderBottom: `1px solid ${palette.jet?.borderDefault} `,
      },
    },
  },
}));

export default styles;
